// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1zIQ1","paramInput":"JobSimulator_paramInput__27_MU","input":"JobSimulator_input___HSx0"};